export const NUMBER_FIELD = 'NUMBER';

export const STRING_FIELD = 'STRING';

export const BOOLEAN_FIELD = 'BOOLEAN';
